import { useAuth0 } from '@auth0/auth0-react';
import useSWR from '../node_modules/swr/core/dist/index.js';
import { convertKeysToCamelCase } from '../utils/dataTransforms.js';

/**
 * Wraps the useSWR with a custom fetcher that handles auth for use
 *
 * What is SWR and how to use it: https://swr.vercel.app/
 *
 * @param {String} url
 * @param {SWRConfiguration} config
 * @returns {SWRResponse}
 */
function useSWRWithAuth(url, config) {
    const { getAccessTokenSilently } = useAuth0();
    return useSWR(url, async (endpoint, options = {}) => {
        const authToken = await getAccessTokenSilently();
        const response = await fetch(endpoint, {
            ...options,
            headers: {
                ...((options === null || options === void 0 ? void 0 : options.headers) || {}),
                Authorization: `Bearer ${authToken}`,
            },
        });
        if (!response.ok) {
            const error = new Error('Api response not ok');
            error.status = response.status;
            error.message = ((await response.json()) || {}).message;
            throw error;
        }
        return convertKeysToCamelCase(await response.json());
    }, config);
}

export { useSWRWithAuth as default };
//# sourceMappingURL=useSWRWithAuth.js.map
